import { Reducer } from 'redux';
import { produce } from 'immer';

import { CERTIFICATES_TYPES, CertificatesState } from './types';

export const INITIAL_STATE: CertificatesState = {
  certificates: {
    hasMore: false,
    response: [],
  },
  error: null,
};

const reducer: Reducer<CertificatesState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case CERTIFICATES_TYPES.SET_DATA_CERTIFICATES:
        draft.certificates = action.payload;
        break;
      case CERTIFICATES_TYPES.SET_ERROR:
        draft.error = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
